import {rpc} from './session';

export async function getTelematicsWithDevices(devices, source, boundingBox = null, mapSize = null, zoom = 18) {
    return await rpc.request('com.rnis.telematics.action.telematics.get', {
        compression: 'precalculated',
        bounding_box: boundingBox,
        map_size: mapSize,
        source,
        devices,
        clusters: true,
        zoom,
    });
}

export async function getTelematics(component, source, boundingBox = null, mapSize = null, zoom = 18) {
    return await rpc.request('com.rnis.telematics.action.telematics.portal.clustered', {
        compression: 'precalculated',
        bounding_box: boundingBox,
        map_size: mapSize,
        source,
        devices: [component],
        clusters: true,
        zoom,
    });
}

export async function getTelematicsTotalCount() {
    return await rpc.request('com.rnis.telematics.action.telematics.portal.get.count', {});
}

export async function telematicsUpdateSubscribe(filter, callback) {
    await rpc.subscribe('com.rnis.telematics.action.telematics.portal.update', callback, filter);
}

export async function filtersUpdate(subject, filters) {
    await rpc.wsRequest('filters', {
        subject,
        filters,
    });
}

export async function telematicsUpdateUnsubscribe() {
    await rpc.unsubscribe('com.rnis.telematics.action.telematics.portal.update');
}


// WEBPACK FOOTER //
// ./src/helpers/api/telematics.js